import { Component } from '@angular/core';

@Component({
  templateUrl: './rewards.page.html',
})
/**
 * Rewards page
 */
export class RewardsPage {}
